module.exports = __webpack_public_path__ + "media/images/chevron-down-4f28f998b7b999c6359606411bb4001d.svg";